import { Booth, Community, IssueType, SocialPost, SocialTrend } from './types';

// Mock Data representing a slice of Borkhetri Constituency
export const MOCK_BOOTHS: Booth[] = [
  {
    id: 'B001',
    number: 1,
    name: 'Mukalmua High School (East)',
    shaktiKendra: 'Mukalmua Central',
    mandal: 'Borkhetri Mandal',
    totalVoters: 850,
    verifiedPannaPramukhs: 12,
    targetPannaPramukhs: 14,
    demographics: [
      { community: Community.INDIGENOUS_ASSAMESE, percentage: 70 },
      { community: Community.BENGALI_HINDU, percentage: 20 },
      { community: Community.MINORITY, percentage: 10 },
    ],
    keyIssues: [IssueType.ORUNODOI, IssueType.ROADS],
    lastElectionTrend: 'BJP',
    latitude: 26.25,
    longitude: 91.50
  },
  {
    id: 'B002',
    number: 2,
    name: 'Loharkatha Primary School',
    shaktiKendra: 'Loharkatha',
    mandal: 'Borkhetri Mandal',
    totalVoters: 720,
    verifiedPannaPramukhs: 5,
    targetPannaPramukhs: 12,
    demographics: [
      { community: Community.MINORITY, percentage: 85 },
      { community: Community.INDIGENOUS_ASSAMESE, percentage: 15 },
    ],
    keyIssues: [IssueType.EROSION, IssueType.PMAY],
    lastElectionTrend: 'AIUDF',
    latitude: 26.23,
    longitude: 91.48
  },
  {
    id: 'B003',
    number: 3,
    name: 'Rampur Community Hall',
    shaktiKendra: 'Rampur',
    mandal: 'Borkhetri Mandal',
    totalVoters: 600,
    verifiedPannaPramukhs: 10,
    targetPannaPramukhs: 10,
    demographics: [
      { community: Community.BENGALI_HINDU, percentage: 60 },
      { community: Community.INDIGENOUS_ASSAMESE, percentage: 40 },
    ],
    keyIssues: [IssueType.PMAY, IssueType.TEMPLE_FUNDING],
    lastElectionTrend: 'BJP',
    latitude: 26.27,
    longitude: 91.52
  },
  {
    id: 'B004',
    number: 4,
    name: 'Bartala LP School',
    shaktiKendra: 'Mukalmua Central',
    mandal: 'Borkhetri Mandal',
    totalVoters: 900,
    verifiedPannaPramukhs: 8,
    targetPannaPramukhs: 15,
    demographics: [
      { community: Community.INDIGENOUS_ASSAMESE, percentage: 90 },
      { community: Community.MINORITY, percentage: 10 },
    ],
    keyIssues: [IssueType.ORUNODOI, IssueType.ROADS],
    lastElectionTrend: 'INC',
    latitude: 26.26,
    longitude: 91.51
  }
];

export const CANDIDATE_NAME = "Shashibhusan Deka";
export const CONSTITUENCY = "Borkhetri (Assam)";
export const ELECTION_YEAR = "2026";

// Social Media Mock Data
export const MOCK_SOCIAL_POSTS: SocialPost[] = [
  {
    id: 'p1',
    platform: 'Facebook',
    author: 'Assam Political Watch',
    content: 'Massive turnout at Shashibhusan Deka’s rally in Mukalmua today. The Orunodoi promise seems to be working. #Borkhetri2026',
    sentiment: 'Positive',
    likes: 1240,
    shares: 340,
    timestamp: '2h ago'
  },
  {
    id: 'p2',
    platform: 'Twitter',
    author: 'Opposition Voice',
    content: 'River erosion in Loharkatha is being ignored by the ruling party. Where are the embankments promised? #SaveBorkhetri',
    sentiment: 'Negative',
    likes: 85,
    shares: 45,
    timestamp: '4h ago'
  },
  {
    id: 'p3',
    platform: 'WhatsApp',
    author: 'Booth President (Group Forward)',
    content: 'Rumor alert: Opposition spreading fake news about Orunodoi forms being rejected. Please verify with Shakti Kendra Probhari.',
    sentiment: 'Negative',
    likes: 0,
    shares: 0,
    timestamp: '15m ago'
  },
  {
    id: 'p4',
    platform: 'Instagram',
    author: 'Youth4Change',
    content: 'New road project inaugurated near Rampur. Development is visible! 🚜🛣️',
    sentiment: 'Positive',
    likes: 560,
    shares: 20,
    timestamp: '6h ago'
  }
];

// Additional posts to simulate live incoming feed
export const INCOMING_SOCIAL_POSTS: SocialPost[] = [
  {
    id: 'p5',
    platform: 'Twitter',
    author: 'Political Insider Assam',
    content: 'Breaking: Senior leaders expected to visit Borkhetri next week to review booth committee strength. #Mission2026',
    sentiment: 'Neutral',
    likes: 42,
    shares: 15,
    timestamp: 'Just now'
  },
  {
    id: 'p6',
    platform: 'Facebook',
    author: 'Local Resident',
    content: 'Thank you Shashibhusan Sir for the new tubewell in our village. Water problem solved! 🙏',
    sentiment: 'Positive',
    likes: 89,
    shares: 12,
    timestamp: 'Just now'
  },
  {
    id: 'p7',
    platform: 'WhatsApp',
    author: 'Panna Pramukh (Booth 4)',
    content: 'Meeting with beneficiaries completed. 15 new families added to the support list.',
    sentiment: 'Positive',
    likes: 0,
    shares: 0,
    timestamp: 'Just now'
  }
];

export const MOCK_SOCIAL_TRENDS: SocialTrend[] = [
  { id: 't1', hashtag: '#BorkhetriWithModi', volume: 15400, trend: 'up' },
  { id: 't2', hashtag: '#ErosionCrisis', volume: 8200, trend: 'up' },
  { id: 't3', hashtag: '#Orunodoi3.0', volume: 12100, trend: 'stable' },
  { id: 't4', hashtag: '#ScamAlert', volume: 3400, trend: 'down' }
];